import apiClient from "../http/apiClient";
import { PRODUCTS_ENDPOINTS } from "../http/endpoints";

const detailUrl = (basePath, id) => `${basePath}${id}/`;
const toggleActiveUrl = (id) => `${PRODUCTS_ENDPOINTS.products}${id}/toggle-active/`;
const barcodesUrl = (productId) => `${PRODUCTS_ENDPOINTS.products}${productId}/${PRODUCTS_ENDPOINTS.productBarcodesSuffix}`;
const barcodeDetailUrl = (productId, barcodeId) => `${barcodesUrl(productId)}${barcodeId}/`;

export async function list(params = {}, config = {}) {
  const response = await apiClient.get(PRODUCTS_ENDPOINTS.products, { params, ...config });
  return response.data;
}

export async function get(id) {
  const response = await apiClient.get(detailUrl(PRODUCTS_ENDPOINTS.products, id));
  return response.data;
}

export async function create(payload) {
  const response = await apiClient.post(PRODUCTS_ENDPOINTS.products, payload);
  return response.data;
}

export async function createFull(payload) {
  const response = await apiClient.post(PRODUCTS_ENDPOINTS.productsCreateFull, payload);
  return response.data;
}

export async function update(id, payload) {
  const response = await apiClient.patch(detailUrl(PRODUCTS_ENDPOINTS.products, id), payload);
  return response.data;
}

export async function toggleActive(id, is_active) {
  const body = {};
  if (typeof is_active === "boolean") {
    body.is_active = is_active;
  }
  const response = await apiClient.patch(toggleActiveUrl(id), body);
  return response.data;
}

export async function listBarcodes(productId, params = {}) {
  const response = await apiClient.get(barcodesUrl(productId), { params });
  return response.data;
}

export async function createBarcode(productId, payload) {
  const response = await apiClient.post(barcodesUrl(productId), payload);
  return response.data;
}

export async function updateBarcode(productId, barcodeId, payload) {
  const response = await apiClient.patch(barcodeDetailUrl(productId, barcodeId), payload);
  return response.data;
}

export const productsService = {
  list,
  get,
  create,
  createFull,
  update,
  toggleActive,
  listBarcodes,
  createBarcode,
  updateBarcode,
};

export default productsService;
